import { render, staticRenderFns } from "./redBag.vue?vue&type=template&id=e72e3dcc&"
import script from "./redBag.vue?vue&type=script&lang=js&"
export * from "./redBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports